import { render, staticRenderFns } from "./serviceItem.vue?vue&type=template&id=12eea0a0"
import script from "./serviceItem.vue?vue&type=script&lang=js"
export * from "./serviceItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports